import { AlarmSignalR } from 'domain/alarm-signal-r'
import { SignalRAlarmType } from 'enums/signal-r-alarm-type'
import { AnprCriterionTypeEnum } from 'features/alarms/types/alarm.types'

const DEMO_CAMERAS = ['Veículos - Entrada']

const DEMO_PLATES = ['ABC1D23', 'RTG7A88', 'QXP4E19', 'BSC2C05']

// Values must match the configured criteria vocabulary (alarm-consts), since the
// dialog resolves them through getCriterionDisplayValue.
const DEMO_COLORS = ['Black', 'White', 'Gray', 'Red']

const pick = <T,>(values: T[]): T =>
  values[Math.floor(Math.random() * values.length)]

/**
 * Builds a plausible alarm payload for demonstrations. Sent through the hub's
 * BroadcastAlarmEvent so it travels the exact same path as a real alarm - the
 * browser receives it back on the 'anpr-alarm' handler like any other.
 */
export const buildDemoAlarm = (
  type: SignalRAlarmType = SignalRAlarmType.ANPR
): AlarmSignalR => {
  const now = new Date().toISOString()

  return {
    createdDate: now,
    alarmDate: now,
    // Real alarms carry the camera snapshot here; a simulated one has no capture.
    alarmImageUrl: '',
    createdBy: 'Simulação',
    type,
    cameraName: pick(DEMO_CAMERAS),
    criterias: [
      { type: AnprCriterionTypeEnum.LICENSE_PLATE, value: pick(DEMO_PLATES) },
      { type: AnprCriterionTypeEnum.COLOR, value: pick(DEMO_COLORS) },
      { type: AnprCriterionTypeEnum.TYPE, value: 'cars' },
    ],
  }
}
